import { render, staticRenderFns } from "./opening-supplier-add-or-update.vue?vue&type=template&id=50e8aa3a&scoped=true"
import script from "./opening-supplier-add-or-update.vue?vue&type=script&lang=js"
export * from "./opening-supplier-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./opening-supplier-add-or-update.vue?vue&type=style&index=0&id=50e8aa3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8aa3a",
  null
  
)

export default component.exports